<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-8">
                        <h5 class="card-title">
                            <span class="mdi mdi-access-point-network text-muted"></span> Connected Clients
                        </h5>
                        <p>Select a connected client to view tests uploaded by that client only</p>
                    </div>
                </div>

                <!-- Loading info -->
                <div class="d-flex d-flex justify-content-center mt-5 mb-5" v-if="viewState == 'Busy'">
                    <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
                </div>
                <!-- /Loading info -->      

                <div v-if="connectedClients && connectedClients.length > 0 && viewState != 'Busy'">
                    <b-table ref="testDataTable"
                        striped hover small
                        selectable
                        select-mode="single"
                        class="mt-3"
                        @row-selected="onRowSelected"
                        :items="connectedClients"
                        :fields="fields">                        
                    </b-table>

                    <!-- <div class="row mt-4">
                        <div class="col">
                            <strong>{{ totalTests }}</strong> results
                            <span v-if="totalPages > 1">
                                | Page <strong>{{ pageNumber }}</strong> of <strong>{{ totalPages }}</strong> 
                            </span>
                        </div>
                        <div class="col" :style="totalPages == 1 ? 'display: none;' : ''">
                            <div class="float-right">
                                <button class="btn btn-success btn-sm mr-2" :disabled="pageNumber == 1" @click="previousPage">
                                    &laquo; Previous
                                </button>
                                <button class="btn btn-success btn-sm" :disabled="pageNumber == totalPages" @click="nextPage">
                                    Next &raquo;
                                </button>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return  {
                connectedClients: null,
                fields: [
                    { key: 'client_name', label: 'Name' },
                    { key: 'client_type', label: 'Client Type' },
                    { key: 'location_name', label: 'Location' }
                ]
            }
        },
        async mounted() {
            this.connectedClients = [
                {
                    client_id: 'cl_6691a0b227924d6fa3c9bd83cf8c5d8b',
                    client_type: 'Mobile Emissions Unit',
                    client_name: 'Airport Emissions Device 1',
                    location_name: 'Boston Demo Airport'
                },
                 {
                    client_id: 'cl_c6f98283ad0d460aa13a33977f5541bd',
                    client_type: 'Mobile Emissions Unit',
                    client_name: 'Airport Emissions Device 2',
                    location_name: 'Boston Demo Airport'
                }
            ]
        },
        methods: {
            onRowSelected(items) {
                if (items.length > 0) {
                    this.$router.push({
                        name: 'client-details',
                        params: {
                            clientId: items[0].client_id,
                            clientData: items[0]
                        }
                    })
                }
                this.$refs.testDataTable.clearSelected()
            },
        }
    }
</script>
